import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/templates/Layout";
import ResetCredentials from "./pages/ResetCredentials";
import ResetMfa from "./pages/ResetMfa";
import RecreateRG from "./pages/RecreateRG";

const FullReadAccess = lazy(() => import("./pages/FullReadAccess"));

export default function App() {
  return (
    <Layout>
      <Routes>
        {/* Public routes - no authentication required */}
        <Route path="/reset-credentials" element={<ResetCredentials />} />
        <Route path="/reset-mfa" element={<ResetMfa />} />
        <Route path="/recreate-rg" element={<RecreateRG />} />
        
        {/* Full Read Access route */}
        <Route
          path="/full-read-access"
          element={
            <Suspense
              fallback={
                <div style={{ padding: 24, textAlign: "center" }}>
                  Loading…
                </div>
              }
            >
              <FullReadAccess />
            </Suspense>
          }
        />
        
        {/* Default route - redirect to reset-credentials */}
        <Route path="/" element={<Navigate to="/reset-credentials" replace />} />
      </Routes>
    </Layout>
  );
}
